import { Fragment, useMemo } from 'react'

import { FireLink } from '@nx/fire/link'
import { SmartlingAttributes } from '@nx/smartling'

import { BreadcrumbsContainer } from './FireBreadcrumbs.styles'

export function FireBreadcrumbs({
  linksStructure,
  ...props
}: FireBreadcrumbsProps) {
  const links = useMemo(
    () =>
      linksStructure.map((linkStructure) =>
        linkStructure.url ? (
          <FireLink href={linkStructure.url}>
            <span
              {...(!linkStructure.translate && SmartlingAttributes.noTranslate)}
            >
              {linkStructure.title}
            </span>
          </FireLink>
        ) : (
          <span
            {...(!linkStructure.translate && SmartlingAttributes.noTranslate)}
          >
            {linkStructure.title}
          </span>
        )
      ),
    [linksStructure]
  )

  return (
    <BreadcrumbsContainer {...props} as="nav">
      {links.map((link, index) => {
        return index < links.length - 1 ? (
          <Fragment key={index}>
            {link}
            {' / '}
          </Fragment>
        ) : (
          <Fragment key={index}>{link}</Fragment>
        )
      })}
    </BreadcrumbsContainer>
  )
}

export interface FireBreadcrumbsProps {
  linksStructure: {
    title: string
    url?: string
    translate: boolean
  }[]
}
